import Vue from 'vue'
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const router = new VueRouter({
    base: '/heiliger/',
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Login',
            component: () => import('@/views/Login/LoginEmail')
        },
        {
            path: '/selectSignature',
            name: 'Signature',
            component: () => import('@/views/Login/LoginSignature')
        },
        {
            path: '/password',
            name: 'Password',
            component: () => import('@/views/Login/LoginPassword')
        },
        {
            path: '/home',
            name: 'Home',
            component: () => import('@/views/Home/Home'),
            children: [
                {
                    path: '/kpis',
                    name: 'KPIS',
                    component: () => import('@/views/Home/KPI/Kpis')
                },
                {
                    path: '/listDemmands',
                    name: 'ListDemmands',
                    component: () => import('@/views/Home/Demmands/ListDemmands')
                },
                {
                    path: '/listOrder',
                    name: 'ListOrder',
                    component: () => import('@/views/Home/Order/ListOrder')
                },
                {
                    path: '/calendar',
                    name: 'Calendar',
                    component: () => import('@/views/Home/Calendar/Calendar')
                },
                {
                    path: '/menu',
                    name: 'Menu',
                    component: () => import('@/views/Home/Menu/Menu')
                },
            ],
        },
        {
            path: '/addUpdateDemmandsInteraction',
            name: 'AddUpdateDemmandsInteraction',
            component: () => import('@/views/Home/Demmands/AddUpdateDemmandsInteraction/AddUpdateDemmandsInteraction'),
            children: [
                {
                    path: '/addUpdateDemmands',
                    name: 'AddUpdateDemmands',
                    component: () => import('@/views/Home/Demmands/AddUpdateDemmandsInteraction/AddUpdateDemmands')
                },
                {
                    path: '/interactions',
                    name: 'Interactions',
                    component: () => import('@/views/Home/Demmands/AddUpdateDemmandsInteraction/Interactions')
                }
            ],
        },
        {
            path: '/pdv',
            name: 'pdv',
            component: () => import('@/views/Home/Order/Pdv'),
        },
        {
            path: '/addUpdateOrder',
            name: 'AddUpdateOrder',
            component: () => import('@/views/Home/Order/AddUpdateOrder'),
        },
        {
            path: '/qrCode',
            name: 'QrCode',
            component: () => import('@/views/Home/Demmands/AddUpdateDemmandsInteraction/QrCode'),
        },
        {
            path: '/qrCodeOrder',
            name: 'QrCodeOrder',
            component: () => import('@/views/Home/Order/QrCode'),
        },
        {
            path: '/barCode',
            name: 'BarCode',
            component: () => import('@/components/barCode/BarCode'),
        }
    ]
});
  
export default router